<template>

    <v-row class="align-v-row">
        <v-col
            cols="12"
            md="4"
        >
            <label class="v-subheader label-padding theme--light">
                {{ formattedDataSourceType }}
            </label>
        </v-col>

        <v-col
            cols="12"
            md="8"
        >
            <v-select
                class='input-text input-text--select body-text'
                :placeholder="$t('reports.select')"
                v-model="selectedDataSource"
                :items="availableDataSourcesByType"
                item-text="title"
                item-value="id"
                :rules="rules.dataSource"
                outlined
                dense
            >
                <template #no-data>
                    <span class="font-weight-light pl-3">{{ $t('reports.no_data_available') }}</span>
                </template>
            </v-select>
        </v-col>

        <v-col
            cols="12"
            md="1"
        >
            <v-btn
                class='btn-icon--delete btn-icon my-1'
                v-if="showTrashIcon"
                @click="close"
            >
                <v-icon>mdi-trash-can</v-icon>
            </v-btn>
        </v-col>
    </v-row>

</template>

<script>
import _ from "lodash";
import {i18n} from "@/i18n";

export default {
    name: "DataSourceSelect",

    props: {
        availableDataSources: {
            type: Array || undefined,
        },
        previousSelectedDataSources: {
            type: Array,
            default: [],
        },
        dataSourcesByTypes:{
            type: Object,
            default: {},
        },
        dataSourceType:{
            type:String,
            default:''
        }
    },

    data() {
        return {

            dataSources:[],

            selectedDataSource: '',

            rules: {
                dataSourceType: [
                    v => !!v || i18n.t('reports.create_form.required_fields.data_source_type'),
                ],
                dataSource: [
                    v => !!v || i18n.t('reports.create_form.required_fields.data_source'),
                ],
            }
        }
    },

    computed: {

        /**
         * Gets data-sources with given type
         *
         * @returns {Array}
         */
        availableDataSourcesByType() {
            if(!this.availableDataSources)
                return [];

            let dataSources = _.filter(
                this.availableDataSources, (dataSource) => dataSource.class === this.dataSourceType
            );

            return _.map(dataSources, (dataSource) => {
                return {
                  ...dataSource,
                  disabled: this.previousSelectedDataSources.includes(dataSource.id)
                      && this.selectedDataSource !== dataSource.id,
                };
            })
        },

        /**
         * Validation of the old bible reference to rename it to -> RECU
         *
         * @returns {VueI18n.TranslateResult|string}
         */
        formattedDataSourceType() {
            return this.dataSourceType === 'BIBLE'
                ? this.$t('reports.data_source_types.bible')
                : this.dataSourceType;
        },
    },

    watch: {
        selectedDataSource(newValue, oldValue) {
            let datasource = {
                class: this.dataSourceType,
                id:newValue
            }
            this.$emit('onSelectDataSources', datasource, oldValue);
        }
    }
}
</script>

<style scoped>
.label-padding {
    padding: 0;
}

.align-v-row {
    align-items: baseline;
}
</style>
